import React from 'react';

export default function BackToTop({ scroll }) {
  const handleClick = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // If parent passes an explicit `scroll` prop, respect it.
  // If no prop is passed (parent conditionally mounts the component), show by default.
  const shouldShow = typeof scroll === 'undefined' ? true : !!scroll;

  return (
    <>
      {shouldShow && (
        <button
          type="button"
          className="scroll-to-target scroll-to-top"
          onClick={handleClick}
          aria-label="Back to top"
        >
          <i className="fas fa-arrow-up"></i>
        </button>
      )}
    </>
  );
}
